import * as React from "react";

export interface Props {
  name: string;
}

export function getPortalId(name: string) {
  return `wtd-modal-portal__${name}`;
}

class ModalPortal extends React.Component<Props> {
  public render() {
    const { name } = this.props;
    return <div id={getPortalId(name)} />;
  }
}

export default ModalPortal;



// WEBPACK FOOTER //
// ./frontend/src/common/components/modal/ModalPortal.tsx